import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-view-form-dynamic',
  template: '<button class="btn btn-warning btn-xs mb-1" [disabled]="disableUpdated" [hidden]="hidenUpdated"' +
            '(click)="onClick()">Modificar</button> ' +
            '<button class="btn btn-danger btn-xs" [disabled]="disableDelete" [hidden]="hiddenDelete" ' +
            '(click)="onClick(\'delete\')">Eliminar</button>' + 
            '<button class="btn btn-warning btn-xs" [hidden]="disableDetail" ' +
            '(click)="onClick(\'detail\')">Detalles</button>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class ButtonsActionsTableComponent implements ViewCell, OnInit {
  // contiene el valor de entrada
  renderValue: number;
  // entrada del valor del boton
  @Input() value: number;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();
  // Define cuando mostrar el boton de modificar
  disableUpdated = false;
  // Define cuando mostrar el boton de eliminar
  disableDelete = false;
  // Define cuando bloquear el boton de ver detalles
  disableDetail =  true;
  hiddenDelete = false;

  // Define cuando mostrar el boton de modificar
  hidenUpdated = false;
  // Define cuando mostrar el boton de eliminar
  hidenDelete = false;
  // Define cuando mostrar el boton de ver
  hidensView = false;
  // Define cuando bloquear el boton de ver
  viewDetail = false;


  ngOnInit() {
    this.renderValue = this.value;
    if (this.rowData.hasOwnProperty('delete')) {
      this.disableDelete = !this.rowData['delete'];
      this.hidenDelete = !this.rowData['delete'];
    }
    if (this.rowData.hasOwnProperty('update')) {
      this.disableUpdated = !this.rowData['update'];
      this.hidenUpdated = !this.rowData['update'];
    }
    if (this.rowData.hasOwnProperty('created')) {
      this.hidensView = !this.rowData['created'];
    } else if (this.rowData.hasOwnProperty('update')) {
      this.hidensView = !this.rowData['update'];
    }
    if (this.rowData.hasOwnProperty('review')) {
      this.hidensView = !this.rowData['review'];
    }
    if (this.rowData.hasOwnProperty('detail')) {
      this.disableDetail = this.rowData['detail'];
    }
  }
  /**
   * Emite el evento retornando la data de la fila selecionada al dar click en el boton
   *
   * @memberof ButtonsAccionDynamicFormsTableComponent
   */
  onClick(action: string = 'update') {
    if (
      (action === 'update' && !this.disableUpdated) ||
      (action === 'delete' && !this.disableDelete) ||
      (action === 'detail' && !this.disableDetail)
    ) {
      const dataEmit = {
        'action': action,
        'data': this.rowData
      };
      this.save.emit(dataEmit);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/buttons-actions-table.component.ts